export default __webpack_public_path__ + "static/media/female_head.78825325.png";